export const serviceIcons = [
  { value: 'handyman', label: 'General', symbol: 'handyman' },
  { value: 'car', label: 'Car', symbol: 'directions_car' },
  { value: 'periodic', label: 'Periodic', symbol: 'event_repeat' },
  { value: 'inspection', label: 'Inspection', symbol: 'fact_check' },
  { value: 'diagnostics', label: 'Diagnostics', symbol: 'memory' },
  { value: 'engine', label: 'Engine', symbol: 'settings' },
  { value: 'oil', label: 'Oil', symbol: 'opacity' },
  { value: 'filter', label: 'Filter', symbol: 'filter_alt' },
  { value: 'coolant', label: 'Coolant', symbol: 'water_drop' },
  { value: 'fuel', label: 'Fuel', symbol: 'local_gas_station' },
  { value: 'battery', label: 'Battery', symbol: 'battery_charging_full' },
  { value: 'electrical', label: 'Electrical', symbol: 'electrical_services' },
  { value: 'spark', label: 'Ignition', symbol: 'bolt' },
  { value: 'brakes', label: 'Brakes', symbol: 'car_repair' },
  { value: 'tyres', label: 'Tyres', symbol: 'tire_repair' },
  { value: 'alignment', label: 'Alignment', symbol: 'straighten' },
  { value: 'suspension', label: 'Suspension', symbol: 'tune' },
  { value: 'transmission', label: 'Gearbox', symbol: 'settings_applications' },
  { value: 'clutch', label: 'Clutch', symbol: 'sync_alt' },
  { value: 'exhaust', label: 'Exhaust', symbol: 'air' },
  { value: 'ac', label: 'A/C', symbol: 'ac_unit' },
  { value: 'hvac', label: 'Climate', symbol: 'mode_fan' },
  { value: 'radiator', label: 'Radiator', symbol: 'device_thermostat' },
  { value: 'lights', label: 'Lights', symbol: 'lightbulb' },
  { value: 'glass', label: 'Glass', symbol: 'window' },
  { value: 'body', label: 'Body', symbol: 'auto_fix_high' },
  { value: 'dent', label: 'Dent / crash', symbol: 'car_crash' },
  { value: 'paint', label: 'Paint', symbol: 'format_paint' },
  { value: 'polish', label: 'Polish', symbol: 'auto_awesome' },
  { value: 'wash', label: 'Wash', symbol: 'local_car_wash' },
  { value: 'detailing', label: 'Detailing', symbol: 'cleaning_services' },
  { value: 'interior', label: 'Interior', symbol: 'airline_seat_recline_extra' },
  { value: 'audio', label: 'Audio', symbol: 'speaker' },
  { value: 'keys', label: 'Keys', symbol: 'key' },
  { value: 'warranty', label: 'Warranty', symbol: 'verified' },
  { value: 'shield', label: 'Cover', symbol: 'shield' },
  { value: 'ev', label: 'EV', symbol: 'electric_car' },
  { value: 'charging', label: 'Charging', symbol: 'ev_station' },
  { value: 'towing', label: 'Towing', symbol: 'rv_hookup' },
  { value: 'pickup', label: 'Pickup', symbol: 'local_shipping' },
  { value: 'fleet', label: 'Fleet', symbol: 'garage' },
  { value: 'motorcycle', label: 'Motorcycle', symbol: 'two_wheeler' },
  { value: 'emergency', label: 'Emergency', symbol: 'e911_emergency' },
  { value: 'quote', label: 'Quote', symbol: 'request_quote' },
  { value: 'welding', label: 'Welding', symbol: 'whatshot' },
  { value: 'tools', label: 'Tools', symbol: 'build' },
  { value: 'engineering', label: 'Workshop', symbol: 'engineering' },
  { value: 'health', label: 'Safety', symbol: 'health_and_safety' },
];

export function serviceIcon(value) {
  return serviceIcons.find((icon) => icon.value === value) || serviceIcons[0];
}
